import React from "react";
import axios from "axios";

import { Dialog, DialogActions, DialogContent, DialogTitle, FormLabel, Slide } from "@mui/material";
import { Close, GetApp } from "@mui/icons-material";

import Button from "../../../components/CustomButtons/Button";
import CustomSwitch from "../../../components/CustomInput/CustomSwitch";
import SaveButton from "../../../components/CustomInput/SaveButton";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class DownloadVoucherQRCodes extends React.Component {
  state = {
    saving: false,
    downloadLink: null,
    withWebCode: false,
    withImage: false,
    withExcelDataFile: true,
  };

  fileInput = React.createRef();

  /**
   * Handler voor customSwitch
   */
  handleCheckbox = (name) => (event) => {
    let state = { ...this.state };
    state[name] = event.target.checked;
    this.setState(state);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && prevProps.open !== this.props.open) {
      this.setState({
        saving: false,
        downloadLink: null,
      });
    }
  }

  download = () => {
    this.setState({ saving: true });

    let data = new FormData();

    data.append("ids", this.props.selectedTafelIds);
    data.append("withWebCode", this.state.withWebCode ? 1 : 0);
    data.append("withQrImage", this.state.withImage ? 1 : 0);
    data.append("withExcelDataFile", this.state.withExcelDataFile ? 1 : 0);

    if (this.fileInput.current !== null && this.state.withImage && this.fileInput.current.files.length > 0) {
      data.append("qrImage", this.fileInput.current.files[0]);
    }

    axios
      .post("core/vouchers/downloadqrcodes", data)

      .then((res) => {
        let link = res.data.data.filename;

        this.setState({
          saving: false,
          downloadLink: link,
        });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        fullWidth={true}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <GridContainer>
            <GridItem sm={11} xs={12} />
            <GridItem sm={1} xs={12}>
              <Button
                aria-label={"Close"}
                className={classes.modalCloseButton}
                color={"transparent"}
                justIcon
                key={"close"}
                onClick={this.props.toggle}
              >
                <Close className={classes.modalClose} />
              </Button>
            </GridItem>
          </GridContainer>
          <h5>
            <TranslationWrapper tDefault={"Download QR-Codes"} tKey={"tafels.modal.downloadQrCode.form.title"} />
          </h5>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem sm={6} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"met webcode onderschrift"}
                  tKey={"tafels.modal.downloadQrCode.form.withWebCode"}
                />
              </FormLabel>
            </GridItem>
            <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
              <CustomSwitch
                checked={this.state.withWebCode}
                name={"withWebCode"}
                onChange={this.handleCheckbox("withWebCode")}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem sm={6} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"Met afbeelding in het midden"}
                  tKey={"tafels.modal.downloadQrCode.form.withImage"}
                />
              </FormLabel>
            </GridItem>
            <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
              <CustomSwitch
                checked={this.state.withImage}
                name={"withImage"}
                onChange={this.handleCheckbox("withImage")}
              />
            </GridItem>
          </GridContainer>
          {this.state.withImage ? (
            <GridContainer>
              <GridItem sm={6} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Afbeelding"} tKey={"tafels.modal.downloadQrCode.form.afbeelding"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={1} xs={12}>
                <input ref={this.fileInput} type={"file"} />
              </GridItem>
            </GridContainer>
          ) : null}

          <GridContainer>
            <GridItem sm={6} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"Add Excel data file (txt & xlsx)"}
                  tKey={"tafels" + "." + "modal.downloadQrCode.form.withExcelDataFile"}
                />
              </FormLabel>
            </GridItem>
            <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
              <CustomSwitch
                checked={this.state.withExcelDataFile}
                name={"withExcelDataFile"}
                onChange={this.handleCheckbox("withExcelDataFile")}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          {this.state.downloadLink === null ? (
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Genereer download file"}
                  tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
                />
              }
              onClick={this.download}
              saving={this.state.saving}
            />
          ) : (
            <Button download={this.state.downloadLink} href={this.state.downloadLink}>
              <GetApp />{" "}
              <TranslationWrapper
                tDefault={"Bestand downloaden"}
                tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
              />
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

export default DownloadVoucherQRCodes;
